//@ts-ignore
import { createBrowserHistory } from 'history';
import AppSettings from '../services/AppSettings';

const history = createBrowserHistory({
    basename: AppSettings.prefix,
});

export default history;
